export enum TextLocations {
  introText = "Intro Text",
  outroText = "Outro Text",
  landingText = "Landing Text",
}

export const TextLocationHelperText: Record<TextLocations, string> = {
  [TextLocations.introText]:
    "Candidates will see this before they begin the assessment. Use it to introduce them to the assessment and platform.",

  [TextLocations.landingText]:
    "Candidates will see this the first time they begin the assessment after the introduction page. Use it to share role-specific details so they can determine whether to continue.",

  [TextLocations.outroText]:
    "Candidates will see this after they complete their assessment. Use it to thank them for completing the assessment and provide next steps.",
};

export const CREATE_NEW_ASSESSMENT_TITLE = "Creating Assessment";
export const CREATE_NEW_ASSESSMENT_DESCRIPTION = "";
